<script setup>
import { onMounted } from 'vue';
import { Link } from '@inertiajs/vue3';
import Layout from "../Components/Layout.vue";

const props = defineProps({
    plan: Object,
    credits: Number,
    subscriptionExpiredAt: String|null,
    subscriptionIsExpired: Boolean,
    subscriptionOutOfCredits: Boolean,
    supportLink: String,
});

const subscriptionIsActive = !props.subscriptionIsExpired && !props.subscriptionOutOfCredits;

const creditsPerImage = props.plan.id === 1 ? 10 : 4;
const creditsMidjourney = Math.floor(props.credits / creditsPerImage);

function getWordForm(number, forms) {
    const n = Math.abs(number) % 100;
    const n1 = n % 10;

    if (n > 10 && n < 20) return forms[2];
    if (n1 === 1) return forms[0];
    if (n1 >= 2 && n1 <= 4) return forms[1];
    return forms[2];
}

onMounted(() => {
    Telegram.WebApp.MainButton.hide();
    Telegram.WebApp.SecondaryButton.hide();
    Telegram.WebApp.BackButton.hide();
});
</script>

<template>
    <Layout>
        <div class="p-4 space-y-4 bg-tgThemeSecondaryBgColor">
            <!-- balance -->
            <div v-if="subscriptionIsActive" class="p-6 bg-tgThemeSectionBgColor rounded-lg">
                <h3 class="text-tgThemeSectionHeaderTextColor">Баланс:</h3>
                <div class="mt-2"><span class="text-xl font-semibold">{{ credits }}</span> {{ getWordForm(credits, ['запрос', 'запроса', 'запросов']) }}</div>
                <div class="mt-1 text-sm" v-if="plan.has_midjourney">или {{ creditsMidjourney }} {{ getWordForm(creditsMidjourney, ['изображение', 'изображения', 'изображений']) }} в Nano Banana</div>
            </div>

            <div class="p-6 bg-tgThemeSectionBgColor rounded-lg">
                <h3 class="text-tgThemeSectionHeaderTextColor">Тариф:</h3>
                <div class="mt-2 font-semibold text-xl">
                    {{ plan['name'] }}
                </div>


                <div v-if="subscriptionIsExpired" class="mt-2 text-sm text-red-600">
                    Срок действия подписки закончился
                </div>

                <div v-if="!subscriptionIsExpired && subscriptionOutOfCredits" class="mt-2 text-sm text-red-600">
                    Закончились запросы
                </div>

                <div v-if="subscriptionIsActive && subscriptionExpiredAt" class="mt-2 text-sm">
                    Закончится через {{ subscriptionExpiredAt }} {{ getWordForm(subscriptionExpiredAt, ['день', 'дня', 'дней']) }}
                </div>

                <div class="mt-2 text-tgThemeTextColor text-sm">
                    <ul>
                        <li v-for="(feature, key) in plan['features']" :key="key" class="flex space-x-2">
                            <span v-html="feature"></span>
                        </li>
                    </ul>
                </div>

                <Link  href="/plan" class="block bg-tgThemeButtonColor text-tgThemeButtonTextColor rounded-lg mt-4 p-3 w-full text-sm text-center">
                    {{ subscriptionIsExpired || subscriptionOutOfCredits ? 'Выбрать новый тариф' : 'Сменить тариф'}}
                </Link>
            </div>

            <a class="block p-4 bg-tgThemeSectionBgColor rounded-lg text-center" :href="supportLink">
                ❤️‍🩹 Поддержка
            </a>

            <div class="pb-4 text-center text-xs text-tgThemeLinkColor">
                <Link href="/docs">Юридическая информация</Link>
            </div>
        </div>
    </Layout>
</template>
